import React from 'react';
import {
  AvatarType,
  SvgAvatar,
  ImageAvatar,
  NoneAvatar,
  Avatar,
} from '@wix/chat-web';
import DefaultAvatar from '../icons/dist/components/defaultAvatar';
import AvatarFemale from '../icons/dist/components/avatarFemale';
import AvatarMale from '../icons/dist/components/avatarMale';
import AvatarNoGender from '../icons/dist/components/avatarNoGender';
import CreatGroup from '../icons/dist/components/createGroup';

const baseAvatar: Avatar = { avatarType: AvatarType.SvgComponent };

// Maps editor settings (key) values to avatar objects (prop)

export const AVATARS = {
  NONE: {
    key: '1',
    prop: { avatarType: AvatarType.None } as NoneAvatar,
  },
  DEFAULT: {
    key: '2',
    prop: { ...baseAvatar, svg: <DefaultAvatar /> } as SvgAvatar,
  },
  IMG: {
    key: '3',
    prop: { avatarType: AvatarType.Image } as ImageAvatar,
  },
  NO_GENDER: {
    key: '4',
    prop: { ...baseAvatar, svg: <AvatarNoGender /> } as SvgAvatar,
  },
  FEMALE: {
    key: '5',
    prop: { ...baseAvatar, svg: <AvatarFemale /> } as SvgAvatar,
  },
  MALE: {
    key: '6',
    prop: { ...baseAvatar, svg: <AvatarMale /> } as SvgAvatar,
  },
};

export const DEFAULT_GROUP_CHAT_AVATAR = {
  ...baseAvatar,
  svg: <CreatGroup />,
} as SvgAvatar;

// UGLY solution:
// Currently server required to have PNG avatar as default
// Once saving PNG and getting it its will not fit to all resolutions.
// To resolve if recognized default URL replacing with SVG Avatar that is not pixled ........
// Should refactor this in the future with server changes to send back default .....
export const DEFAULT_GROUP_CHAT_URL =
  'https://static.wixstatic.com/media/f43338_0f431863800d41f78e515a190c0f9dd7~mv2.png';
